import { forwardRef } from 'react';
import MaterialButton, { ButtonProps } from '@mui/material/Button';

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
    (props, ref) => {
        return (
            <MaterialButton
                ref={ref}
                data-testid={'Button-container'}
                {...props}
            />
        );
    }
);

export default Button;
